import { render, staticRenderFns } from "./Slicings.vue?vue&type=template&id=2359fa5c&"
import script from "./Slicings.vue?vue&type=script&lang=js&"
export * from "./Slicings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports